export function mergeBehaviorActionHandlers(behaviors, actionHandlers) {
	const mergedActionHandlers = {...actionHandlers};
	const {length: behaviorsCount} = behaviors;
	for (let i = 0; i < behaviorsCount; i++) {
		const {
			behavior: {actionHandlers: behaviorActionHandlers, options}
		} = behaviors[i];
		for (const k in behaviorActionHandlers) {
			const behaviorActionHandler = {...behaviorActionHandlers[k], behaviorOptions: options};
			if (mergedActionHandlers[k]) mergedActionHandlers[k].push(behaviorActionHandler);
			else mergedActionHandlers[k] = [behaviorActionHandler];
		}
	}

	return mergedActionHandlers;
}
